var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PieChart',_vm._b({staticClass:"make-a-copy",attrs:{"request-status":_vm.requestStatus,"series":_vm.series,"title":_vm.title,"item-id":_vm.itemId,"show-interval":""},on:{"reload":_vm.getData}},'PieChart',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }